import { render, staticRenderFns } from "./updateBLCF.vue?vue&type=template&id=4ed75323&lang=pug&"
import script from "./updateBLCF.vue?vue&type=script&lang=js&"
export * from "./updateBLCF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports